/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { INotification } from '../../store/notifications/types';
import { NotificationItemFrameOptions } from '../../types/notification/NotificationItemFrameOptions';
import { NotificationItemFrame } from '../NotificationItemFrame/NotificationItemFrame';

type SeeInvitationsNotificationProps = NotificationItemFrameOptions & {
  notification: INotification;
  primaryText: string | React.ReactNode;
  secondaryText?: string | React.ReactNode;
};

export function TextNotification(props: SeeInvitationsNotificationProps) {
  const { notification, primaryText, secondaryText, ...frameProps } = props;

  return (
    <NotificationItemFrame
      {...frameProps}
      isRead={true}
      primaryText={primaryText}
      secondaryText={secondaryText}
      id={notification.id}
    />
  );
}
